<ng-container *transloco="let t">
  @for (item of itemsWithRoute(); track item.sadmEntity.id) {
    <div class="group relative">
      <pxc-sadm-entity-preview
        class="cursor-pointer"
        [attr.data-testid]="'sadmEntity-' + item.sadmEntity.id"
        [routerLink]="item.route"
        [sadmEntity]="item.sadmEntity"
        [sadmType]="$safeNavigationMigration(item.sadmEntity.sadmClient?.sadmType)" />
      <pxc-sadm-document-shortcut [sadmEntity]="item.sadmEntity" />
    </div>
  } @empty {
    <pxc-empty-state
      class="col-span-full"
      data-testid="empty-state"
      icon="@tui.clipboard-list"
      [title]="t('Vous n\'avez aucune lésion pour ce patient.')" />
  }
</ng-container>
